export default __webpack_public_path__ + "static/media/arrow-left-white.408ee56f.svg";